import axios from '../axios';

export const fetchAllArtists = (payload) => axios.post('/artist/all', payload);

export const fetchArtistById = (id) => axios.get(`/artist/${id}`);

export const fetchArtistSongs = (id) => axios.get(`/songs/${id}`);

export const fetchArtistWithdrawals = (id) => axios.get(`/withdraw/${id}`);

export const deleteArtist = (id, shouldDeleteData) => axios.delete(`/artist/${id}?shouldDeleteData=${shouldDeleteData}`);

export const updateArtist = (id, data) => axios.post(`/artist/${id}`, data);

export const updateWithdrawalStatus = (id, data) => axios.post(`/withdraw/${id}`, data);

export const updateWithdraw = (id) => axios.post(`/withdraw/${id}`);

export const uploadAvatar = (id, data) => axios.post(`/artist/${id}/upload-avatar`, data);

export const getAvatarUploadUrl = (id, data) => axios.post(`/artist/${id}/get-avatar-upload-url`, data);

export const fetchDashboard = (payload) => axios.post('/artist/dashboard', payload);

